import React, { useState } from 'react';
import CheckoutListTable from './Components/CheckoutListTable';
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

// Formats a Date object -> "YYYY-MM-DD"
const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const CheckoutList = () => {
  const today = new Date();

  const todayStr = formatDate(today);

  const [filters, setFilters] = useState({
    checkout_date: `${todayStr} to ${todayStr}`,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const pickerValue = filters.checkout_date
    ? filters.checkout_date
      .split(" to ")
      .map((d) => new Date(`${d}T00:00:00`))
    : [today, today];
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Checkout Management</HeadingOne>
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <CheckoutListTable

          filters={filters}
          date={{
            key: "checkout",
            field: {
              name: "checkout_date",
              required: false,
              fieldSize: "p-0",
              placeholder: "Search by Date",
              lableHide: true,
            },
            value: pickerValue,
            handleChange: handleChange,
            error: "",
            selectMode: "range",
          }}
        />
      </div>
    </PageBody>
  );
};

export default CheckoutList;